import React, { Component } from 'react';
import { Field, FieldArray, reduxForm, formValueSelector } from 'redux-form';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import Button from 'react-bootstrap/lib/Button';
import withStyles from 'isomorphic-style-loader/withStyles';

import Image from '../WhyHostFormBlock1/Image';
import FieldArrayComponent from '../../../CommonFields/FieldArrayComponent';

import submit from './submit';
import validate from './validate';
import messages from '../../../../locale/jsonMessages';
import { formatLocaleData } from '../../../../helpers/formatLocale';

import cs from '../../../../components/commonStyle.css';
import s from './WhyHostFormBlock4.css';

const block4ActiveFields = ['easyHostTitle1', 'easyHostContent1', 'easyHostContent2', 'workTitle1', 'workContent1', 'workTitle2', 'workContent2'];

class WhyHostFormBlock4 extends Component {

  render() {
    const { error, handleSubmit, submitting, workImage1, workImage2, workImage3, workImage1Loader, workImage2Loader, workImage3Loader, selectedLanguage } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div>
        <h1 className='siteAdminHeading'><FormattedMessage {...messages.WhyBecomeOwnerBlock4} /></h1>
        <form onSubmit={handleSubmit(submit)}>
          {error && <strong>{formatMessage(error)}</strong>}
          <div className="oneColumnGrid">
            <div className="threeColumnGrid">
              <div className='siteAdminDropZoneWrapper'>
                <label className={cx('commonLabelText', cs.spaceBottom3)}><FormattedMessage {...messages.imageLabel} /> 1</label>
                <Image image={workImage1} fieldName={"workImage1"} loader={workImage1Loader} />
              </div>
              <div className='siteAdminDropZoneWrapper'>
                <label className={cx('commonLabelText', cs.spaceBottom3)}><FormattedMessage {...messages.imageLabel} /> 2</label>
                <Image image={workImage2} fieldName={"workImage2"} loader={workImage2Loader} />
              </div>
              <div className='siteAdminDropZoneWrapper'>
                <label className={cx('commonLabelText', cs.spaceBottom3)}><FormattedMessage {...messages.imageLabel} /> 3</label>
                <Image image={workImage3} fieldName={"workImage3"} loader={workImage3Loader} />
              </div>
            </div>
            <div className='siteAdminCenterContainerBox'>
              <FieldArray
                name="dynamicWhyHostInfoBlock"
                component={FieldArrayComponent}
                activesFields={block4ActiveFields}
                filedName="dynamicWhyHostInfoBlock"
                selectedLanguage={selectedLanguage}
                label={formatMessage(messages.easyHostTitle1)}
                placeholder={formatMessage(messages.easyHostTitle1)}
                isDouble
              />
            </div>
          </div>
          <div className={cx(cs.spaceTop4, 'singleBtnFlexEnd')}>
            <Button className={cx(cs.btnPrimary)} type="submit" disabled={submitting}>
              <FormattedMessage {...messages.save} />
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

WhyHostFormBlock4 = reduxForm({
  form: 'WhyHostForm',
  validate
})(WhyHostFormBlock4);

const selector = formValueSelector('WhyHostForm');

const mapState = (state) => ({
  workImage1Loader: state?.loader?.workImage1,
  workImage2Loader: state?.loader?.workImage2,
  workImage3Loader: state?.loader?.workImage3,
  workImage1: selector(state, 'workImage1'),
  workImage2: selector(state, 'workImage2'),
  workImage3: selector(state, 'workImage3'),
  selectedLanguage: selector(state, 'dynamicWhyHostInfoBlock'),
  activeLanguageCodes: state.runtime.isActiveLanguages.map(item => formatLocaleData(item))
});

export default compose(
  withStyles(cs, s),
  injectIntl,
  connect(mapState, {})
)(WhyHostFormBlock4);
